import { t } from 'i18next';

const getSuggestions = () => [
  {
    key: 'cleaning-service',
    label: t('Cleaning Service'),
  },
  {
    key: 'automotive-services',
    label: t('Automotive Services'),
  },
  {
    key: 'car-detailing-service',
    label: t('Car Detailing Service'),
  },
  {
    key: 'handmade-jewelry',
    label: t('Handmade Jewelry'),
  },
  {
    key: 'beauty-salon',
    label: t('Beauty Salon'),
  },
  {
    key: 'pet-grooming',
    label: t('Pet Grooming'),
  },
  {
    key: 'e-commerce-store',
    label: t('E-commerce Store'),
  },
  {
    key: 'online-fashion-store',
    label: t('Online Fashion Store'),
  },
];

export default getSuggestions;
